import { useAuth } from "@/context/AuthContext";
import { Crown, Zap } from "lucide-react";

/**
 * Fase 1 — Plan badge shown in the app header.
 * Uses only visual chips; no gating logic here.
 */
export default function PlanBadge({ className = "" }) {
  const { effectivePlan, isPro, user } = useAuth();
  if (!effectivePlan) return null;
  const grandfathered = user?.grandfathered;
  return (
    <span
      data-testid="plan-badge"
      data-plan={effectivePlan}
      className={
        (isPro
          ? "bg-[#00F2F4]/12 text-[#00F2F4] border-[#00F2F4]/40"
          : "bg-[var(--bg-3)] text-[var(--fg-2)] border-[var(--border-c)]") +
        " inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-sans font-semibold uppercase tracking-[0.18em] " +
        className
      }
      title={grandfathered ? "Account legacy — limiti storici mantenuti" : undefined}
    >
      {isPro ? <Crown size={11} strokeWidth={2.2} /> : <Zap size={11} strokeWidth={2.2} />}
      {isPro ? "Pro" : "Free"}
      {grandfathered && !isPro && <span className="ml-0.5 opacity-60">·legacy</span>}
    </span>
  );
}
